export const validateAtLeastOneEmploymentType = (formData: {
  isTempwork?: boolean;
  isFreelance?: boolean;
  isEmployee?: boolean;
}) => {
  if (!formData.isTempwork && !formData.isFreelance && !formData.isEmployee) {
    return 'Vul tenminste 1 arbeidsvorm in';
  }
};
